import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core'; 
import { ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, Http, RequestOptions } from '@angular/http';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from "./app-routing.module";

import { DropdownDirective } from './directives/shared/dropdown.directive';

import { NotificationComponent } from './components/shared/notification.component';

//pipes
import { ConvertDatePipe } from './pipes/convert-date.pipe';
import { ConvertDateTimePipe } from './pipes/convert-datetime.pipe';
import { TitleCasePipe } from './pipes/title-case.pipe';

// Kendo
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DialogModule, DialogRef } from '@progress/kendo-angular-dialog';
import { ReCaptchaModule } from 'angular2-recaptcha';

import { FormInputTextComponent } from './components/form/form-input-text.component';
import { FormInputCheckboxComponent } from './components/form/form-input-checkbox.component';
import { FormInputDateComponent } from './components/form/form-input-date.component';
import { FormInputDropdownComponent } from './components/form/form-input-dropdown.component';
import { FormInputTextareaComponent } from './components/form/form-input-textarea.component';

import { AppComponent } from './app.component';
import { HeaderComponent } from './components/anon/header.component';
import { TermsOfServiceComponent } from './components/anon/terms-of-service.component';
import { FooterComponent } from './components/anon/footer.component';
import { PopUpDialogComponent } from './components/anon/popup-dialog.component';

import { ClientIndividualComponent } from './components/shared/client-individual.component';
import { ClientOrganizationComponent } from './components/shared/client-organization.component';

import { PersonInfoComponent } from './components/nonanon/person/person-info.component';
import { PersonInfoByAccessCodeComponent } from './components/nonanon/person/access-code-person-info.component';
import { PersonPhotoComponent } from './components/nonanon/person/person-photo.component';
import { PersonPhotoAccessCodeComponent } from './components/nonanon/person/access-code-person-photo.component';



import { VehicleComponent } from './components/nonanon/vehicle/vehicle.component';
import { VehicleSearchFormComponent } from './components/nonanon/vehicle/vehicle-search-form.component';
import { VehicleInfoComponent } from './components/nonanon/vehicle/vehicle-info.component';
import { VehicleOwnersComponent } from './components/nonanon/vehicle/vehicle-owners.component';


import { WelcomeComponent } from './components/anon/welcome.component';
import { LoginComponent } from './components/anon/login.component';
import { ResetPasswordComponent } from './components/anon/reset-password.component';
import { PasswordChangeComponent } from './components/anon/password-change.component';
import { NotAllowedComponent } from './components/nonanon/not-allowed.component';

//error handler
import { GlobalErrorHandler } from './custom/global-error-handler';


// Services
import { AuthService } from "./services/auth/auth.service";
import { LocalStorageService } from "./services/shared/localStorage.service";
import { AuthGuard } from "./services/auth/auth.guard";

import { LookupService } from "./services/lookups/lookup.service";
import { UserAgreementService } from "./services/lookups/user-agreement.service";
import { ColorResolver } from "./services/lookups/color-resolver.service";
import { ProvinceResolver } from "./services/lookups/province-resolver.service";
import { ALSCauseResolver } from "./services/lookups/als/als-couse-resolver.service";

import { PVService } from "./services/nonanon/pv.service";

import { PersonInfoService } from "./services/nonanon/person/person-info.service";
import { PersonPhotoService } from "./services/nonanon/person/person-photo.service";

import { VehicleService } from "./services/nonanon/vehicle/vehicle.service";
import { VehicleInfoService } from "./services/nonanon/vehicle/vehicle-info.service";

import { AuthHttp, AuthConfig } from 'angular2-jwt';

import { AuthHttpInterceptor } from "./services/auth/authHttp.interceptor";
import { AuthOnlyGuard } from './services/auth/authOnly.guard';
import { GlobalErrorService } from './services/shared/global-error.service';
import { NotificationService } from './services/shared/notification.service';

export function authHttpServiceFactory(http: Http, options: RequestOptions, authService: AuthService) {
    return new AuthHttpInterceptor(http, options, authService);
}

export function lookupServiceFactory(lookupService: LookupService): Function {
    return () => lookupService.load();
}

@NgModule({
    declarations: [
        DropdownDirective,

        FormInputTextComponent, FormInputCheckboxComponent, FormInputDateComponent, FormInputDropdownComponent, FormInputTextareaComponent,

        AppComponent,
        HeaderComponent, FooterComponent, TermsOfServiceComponent,
        PopUpDialogComponent,

        WelcomeComponent, LoginComponent, PasswordChangeComponent, ResetPasswordComponent,

        ClientIndividualComponent, ClientOrganizationComponent,

        VehicleComponent, VehicleSearchFormComponent, VehicleInfoComponent, VehicleOwnersComponent, NotificationComponent, NotAllowedComponent,

    PersonInfoComponent, PersonInfoByAccessCodeComponent, PersonPhotoComponent, PersonPhotoAccessCodeComponent,

        //pipes
        ConvertDatePipe, ConvertDateTimePipe, TitleCasePipe
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,

        FormsModule,
        ReactiveFormsModule,
        HttpModule,

        AppRoutingModule,

        ButtonsModule,
        DropDownsModule,
        DateInputsModule,
        InputsModule,
        DialogModule,
        ReCaptchaModule,
    ],
    providers: [
        AuthService, AuthGuard, AuthOnlyGuard,
        LocalStorageService, TitleCasePipe,

        LookupService, UserAgreementService, ColorResolver, ProvinceResolver, ALSCauseResolver, PopUpDialogComponent,

        PVService, NotificationService, NotificationComponent,

        PersonInfoService, PersonPhotoService,

        VehicleService, VehicleInfoService, GlobalErrorService, DialogRef,
        {
          provide: ErrorHandler,
          useClass: GlobalErrorHandler
        },
        {
            provide: AuthHttp,
            useFactory: authHttpServiceFactory,
            deps: [Http, RequestOptions, AuthService]
        },
        {
            provide: APP_INITIALIZER,
            useFactory: lookupServiceFactory,
            deps: [LookupService],
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/app.module.ts